import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbActiveModal, NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SubscriptionCoupon } from 'src/app/classes/SubscriptionCoupon';

@Component({
  selector: 'app-subscription-coupons-edit',
  styleUrls: ['./subscription-coupons-edit.component.scss'],
  templateUrl: './subscription-coupons-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class SubscriptionCouponsEditComponent implements OnInit {

  @Input() coupon: SubscriptionCoupon;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;

  public minDate: NgbDateStruct;
  public couponForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private calendar: NgbCalendar) {
  }

  ngOnInit(): void {

    this.minDate = this.calendar.getToday();

    if (this.coupon) {
      this.couponForm = this.formBuilder.group({
        id: [this.coupon.id],
        code: [this.coupon.code, Validators.required],
        extraLessonsNumber: [this.coupon.extraLessonsNumber, Validators.required],
      });
    } else {
      this.couponForm = this.formBuilder.group({
        id: [null],
        code: [null, Validators.required],
        extraLessonsNumber: [null, Validators.required],
      });
    }
  }

  convertDate(date: Date): NgbDateStruct {
    return date ? {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    } : null;
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
